import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import { enableMapSet } from "immer";
import mainReducer from "./slices/main";
import populateReducer from "./slices/populate";
import bookmarkReducer from "./slices/bookmark";
import searchReducer from "./slices/search";

enableMapSet();

export const store = configureStore({
  reducer: {
    main: mainReducer,
    populate: populateReducer,
    bookmark: bookmarkReducer,
    search: searchReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
